import { render, staticRenderFns } from "./index_singleselect.vue?vue&type=template&id=51f1f671&scoped=true"
import script from "./index_singleselect.vue?vue&type=script&lang=js"
export * from "./index_singleselect.vue?vue&type=script&lang=js"
import style0 from "./index_singleselect.vue?vue&type=style&index=0&id=51f1f671&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f1f671",
  null
  
)

export default component.exports